
(function diffServiceDefinition() {

    'use strict';

    angular.module('Entities')
        .factory('diff', [
            'restUrlBuilder',
            function diff(restUrlBuilder) {

                return function diff(baseLine, elem) {
                    return restUrlBuilder.diff(baseLine, elem);
                };

            }
        ]);

})();